import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { formatAbs } from './utils';

const StatTile = ({ label, value, accent, testId }) => (
  <div
    className={`rounded-lg border bg-[#0F1730] p-4 ${accent || 'border-[#2A3658]'}`}
    data-testid={testId}
  >
    <div className="text-xs text-slate-400 uppercase tracking-wide">{label}</div>
    <div className="text-2xl font-bold text-white mt-1">{value}</div>
  </div>
);

const EmailStatTiles = ({ stats, statsLoading, days }) => {
  const successRateColor =
    !stats ? 'border-[#2A3658]'
    : stats.success_rate_pct >= 99 ? 'border-emerald-700/40'
    : stats.success_rate_pct >= 95 ? 'border-amber-700/40'
    : 'border-red-700/40';

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <StatTile
          label={`Total sent (last ${days}d)`}
          value={statsLoading ? '…' : (stats?.total || 0).toLocaleString()}
          testId="stat-total-sent"
        />
        <StatTile
          label="Success rate"
          value={statsLoading ? '…' : `${stats?.success_rate_pct ?? 100}%`}
          accent={successRateColor}
          testId="stat-success-rate"
        />
        <StatTile
          label="Failed"
          value={statsLoading ? '…' : (stats?.failed || 0).toLocaleString()}
          accent={(stats?.failed || 0) > 0 ? 'border-red-700/40' : ''}
          testId="stat-failed"
        />
        <StatTile
          label="Sent last 24h"
          value={statsLoading ? '…' : (stats?.sent_24h || 0).toLocaleString()}
          testId="stat-sent-24h"
        />
      </div>

      {stats?.last_failure && (
        <Card className="border-red-800/40 bg-red-950/20 mt-4" data-testid="email-last-failure-card">
          <CardContent className="p-4 flex items-start gap-3">
            <AlertTriangle className="h-5 w-5 text-red-400 flex-shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-red-300">
                Last delivery failure
              </div>
              <div className="text-xs text-slate-300 mt-1 truncate">
                <code className="text-amber-300">{stats.last_failure.to}</code> ·{' '}
                {stats.last_failure.subject}
              </div>
              <div className="text-xs text-slate-400 mt-1">
                {formatAbs(stats.last_failure.sent_at)} · status {stats.last_failure.status_code} ·{' '}
                {stats.last_failure.error || '(no error string)'}
              </div>
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default EmailStatTiles;
